import { Record } from 'immutable';

const defaultValues = {
  designs: 0,
  menus: 0,
  recipes: 0,
};

export default class Dashboard extends Record(defaultValues, Dashboard) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
